import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase/config";
import { collection, query, where, onSnapshot, addDoc, orderBy } from "firebase/firestore";
import { useAuth } from "../../../context/AuthContext";
import { useTheme } from "../../../context/ThemeContext";
import Header from "../../../components/Header";
import { registrarAccion } from "../../../utils/trazabilidad";

export default function Prestadores() {
  const { currentUser, userRole, clinicaId, clinicaData } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [prestadores, setPrestadores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalNuevo, setModalNuevo] = useState(false);
  const [nuevo, setNuevo] = useState({
    nombre: '', tipo: 'Obra Social', tipoPresentacion: 'Digital',
    contactoNombre: '', contactoEmail: '', contactoTelefono: '',
    procedimientoFacturacion: '', observaciones: '', activo: true
  });

  const canEdit = ['gestion_general', 'administracion'].includes(userRole);

  const btnPrimaryStyle = { background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`, border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: '#FFFFFF', fontWeight: '600', fontFamily: "'Montserrat', sans-serif" };
  const btnSecondaryStyle = { background: 'transparent', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: theme.secondary, fontFamily: "'Montserrat', sans-serif" };
  const inputStyle = { width: '100%', padding: '10px 14px', fontSize: '13px', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', outline: 'none', color: theme.primary, background: theme.bgInput, boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif" };
  const labelStyle = { fontSize: '11px', color: theme.secondary, display: 'block', marginBottom: '6px', fontWeight: '500', letterSpacing: '1px' };
  const overlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: theme.bgOverlay, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
  const modalStyle = { background: theme.bgModal, borderRadius: '16px', padding: '28px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.3)', border: `0.5px solid ${theme.border}` };

  useEffect(() => {
    if (!clinicaId) return;
    const q = query(collection(db, 'prestadores'), where('clinicaId', '==', clinicaId), orderBy('nombre'));
    const unsub = onSnapshot(q, snap => {
      setPrestadores(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [clinicaId]);

  async function crearPrestador() {
    if (!nuevo.nombre) return;
    await addDoc(collection(db, 'prestadores'), { ...nuevo, clinicaId, creadoEn: new Date() });
    await registrarAccion(currentUser?.email, userRole, 'Prestadores', 'Crear prestador', nuevo.nombre, clinicaId);
    setModalNuevo(false);
    setNuevo({ nombre: '', tipo: 'Obra Social', tipoPresentacion: 'Digital', contactoNombre: '', contactoEmail: '', contactoTelefono: '', procedimientoFacturacion: '', observaciones: '', activo: true });
  }

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Prestadores / OS" backLabel="Dashboard" backRuta="/dashboard" />
      <div style={{ padding: '24px', background: theme.bg }}>
        {canEdit && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
            <button onClick={() => setModalNuevo(true)} style={btnPrimaryStyle}>+ Nuevo prestador</button>
          </div>
        )}

        {loading
          ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px' }}>Cargando...</div>
          : prestadores.length === 0
            ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px', fontSize: '13px' }}>No hay prestadores registrados</div>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {prestadores.map(p => (
                  <div key={p.id} onClick={() => navigate(`/prestadores/${p.id}`)} style={{
                    background: theme.bgCard, borderRadius: '10px', padding: '14px 18px',
                    border: `0.5px solid ${theme.border}`, cursor: 'pointer',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = theme.accent}
                    onMouseLeave={e => e.currentTarget.style.borderColor = theme.border}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: theme.infoBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: '700', color: theme.accent }}>
                        {p.nombre?.[0]}
                      </div>
                      <div>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: theme.primary }}>{p.nombre}</div>
                        <div style={{ fontSize: '12px', color: theme.secondary }}>{p.tipo} · Presentación {p.tipoPresentacion}</div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <span style={{ fontSize: '12px', padding: '3px 10px', borderRadius: '99px', fontWeight: '500', background: p.tipoPresentacion === 'Digital' ? theme.infoBg : theme.warningBg, color: p.tipoPresentacion === 'Digital' ? theme.accent : theme.warning }}>
                        {p.tipoPresentacion}
                      </span>
                      <span style={{ fontSize: '12px', padding: '3px 10px', borderRadius: '99px', fontWeight: '500', background: p.activo ? theme.successBg : theme.bgCard, color: p.activo ? theme.success : theme.secondary }}>
                        {p.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
        }
      </div>

      {modalNuevo && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <span style={{ fontSize: '16px', fontWeight: '600', color: theme.primary }}>Nuevo prestador</span>
              <button onClick={() => setModalNuevo(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: theme.secondary }}>×</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div><label style={labelStyle}>NOMBRE *</label><input value={nuevo.nombre} onChange={e => setNuevo({...nuevo, nombre: e.target.value})} style={inputStyle} /></div>
              <div><label style={labelStyle}>TIPO</label>
                <select value={nuevo.tipo} onChange={e => setNuevo({...nuevo, tipo: e.target.value})} style={inputStyle}>
                  <option value="Obra Social">Obra Social</option>
                  <option value="Prepaga">Prepaga</option>
                  <option value="Mutual">Mutual</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>
              <div><label style={labelStyle}>TIPO DE PRESENTACIÓN</label>
                <select value={nuevo.tipoPresentacion} onChange={e => setNuevo({...nuevo, tipoPresentacion: e.target.value})} style={inputStyle}>
                  <option value="Digital">Digital</option>
                  <option value="Manual">Manual</option>
                </select>
              </div>
              <div><label style={labelStyle}>CONTACTO — NOMBRE</label><input value={nuevo.contactoNombre} onChange={e => setNuevo({...nuevo, contactoNombre: e.target.value})} style={inputStyle} /></div>
              <div><label style={labelStyle}>CONTACTO — EMAIL</label><input value={nuevo.contactoEmail} onChange={e => setNuevo({...nuevo, contactoEmail: e.target.value})} style={inputStyle} /></div>
              <div><label style={labelStyle}>CONTACTO — TELÉFONO</label><input value={nuevo.contactoTelefono} onChange={e => setNuevo({...nuevo, contactoTelefono: e.target.value})} style={inputStyle} /></div>
              <div><label style={labelStyle}>PROCEDIMIENTO DE FACTURACIÓN</label><textarea value={nuevo.procedimientoFacturacion} onChange={e => setNuevo({...nuevo, procedimientoFacturacion: e.target.value})} rows={3} style={{ ...inputStyle, resize: 'vertical' }} /></div>
              <div><label style={labelStyle}>OBSERVACIONES</label><textarea value={nuevo.observaciones} onChange={e => setNuevo({...nuevo, observaciones: e.target.value})} rows={2} style={{ ...inputStyle, resize: 'vertical' }} /></div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '20px' }}>
              <button onClick={crearPrestador} style={btnPrimaryStyle}>Guardar</button>
              <button onClick={() => setModalNuevo(false)} style={btnSecondaryStyle}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}